<!--
 * @Author: jjchen
 * @Date: 2022-08-11 15:04:23
 * @LastEditors: jjchen
 * @LastEditTime: 2022-08-15 17:28:06
 * @Description: 
-->
<template>
  <div :class="className">
    <van-button :class="currentIndex == index ? 'highLight' : ''" type="default" v-for="(item, index) in options" :key="index" @click="onClick(item, index)">{{ item }}</van-button>
  </div>
</template>
<script>
export default {
  name: 'RadioButton',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: String,
    options: Array,
    flag: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      className: 'layoutOne',
      currentIndex: null,
    }
  },
  created() {
    // console.log(this.checked)
  },
  watch: {
    flag: {
      immediate: true,
      handler(val) {
        if (val == 0) {
          this.className = 'layoutOne'
        } else if (val == 1) {
          this.className = 'layoutTwo'
        } else if (val == 2) {
          this.className = 'layoutThree'
        } else {
          this.className = 'layoutFour'
        }
      },
    },
  },
  methods: {
    onClick(value, index) {
      this.$emit('change', value)
      this.currentIndex = index
    },
  },
}
</script>
<style lang="less" scoped>
button {
  font-size: 0.26rem;
  min-width: 1.5rem;
  height: 0.65rem;
  border-radius: 6px;
}
.layoutOne {
  margin-top: 0.24rem;
  button {
    margin-right: 0.3rem;
  }
}
.layoutTwo {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 0.24rem;
  grid-column-gap: 0.3rem;
  margin-top: 0.24rem;
}
.layoutThree {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-row-gap: 0.24rem;
  grid-column-gap: 0.3rem;
  margin-top: 0.24rem;
}
.layoutFour {
  margin-top: 0.24rem;
  button {
    width: 6.5rem;
    margin-bottom: 0.24rem;
  }
  :last-child {
    margin-bottom: 0;
  }
}
.highLight {
  border-color: #3371ff;
  color: #3371ff;
}
</style>
